import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin, faTwitter } from "@fortawesome/free-brands-svg-icons";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { LinkedinShareButton, TwitterShareButton } from "react-share";
import { useLocation } from "@reach/router";

const Share = styled.div`
  font-size: 14px;
  line-height: 22px;
  > h6 {
    font-weight: 500;
    font-size: 10px;
    line-height: 10px;
    text-transform: uppercase;
    color: #ffffff;
    opacity: 0.6;
  }

  a {
    color: #fff;
    font-weight: bold;
  }

  > * + h6 {
    margin-top: 20px;
  }

  > div {
    margin-left: -10px;
  }

  button:focus {
    outline: none;
  }
`;

const Icon = styled(FontAwesomeIcon)`
  color: white;
  font-size: 24px;
  margin: 10px;
  cursor: pointer;
`;

const ShareButtons = () => {
  const location = useLocation();
  const shareLink = location.href;

  return (
    <Share>
      <h6>Share With Friends</h6>
      <div>
        <LinkedinShareButton url={shareLink} title="Spectro Cloud Builder Game">
          <Icon icon={faLinkedin} />
        </LinkedinShareButton>
        <TwitterShareButton url={shareLink} title="Spectro Cloud Builder Game">
          <Icon icon={faTwitter} />
        </TwitterShareButton>
      </div>
      <h6>Contact us</h6>
      <a href="https://spectrocloud.com/contact">Get 15 mins with us!</a>
    </Share>
  );
};

export default ShareButtons;
